<template>
  <div>
    <!--:class="hidden?'btn-hidden':'btn-show'"-->
    <create-task-dropdown
      ref="CreateTaskDropdown"
      :size="'small'"
      class="btn-normal create-btn"
      style="text-align: left"
      :showCreateButton="showCreateButton"
      @Success="$emit('successed')"
    ></create-task-dropdown>
    <el-button
      @click="reapply"
      type="primary"
      class="btn-normal-st btn-normal "
      v-show="curTask.STATE === 1 && curTask.CREATEUSERID == userId"
      size="small"
      >重新申请</el-button
    >
    <el-button
      type="primary"
      v-if="!hidden"
      class="btn-normal-st btn-normal "
      v-show="curTask.STATE === 0"
      size="small"
      @click="passApprove"
      >审批通过</el-button
    >
    <el-button
      @click="refuseApprove"
      v-if="!hidden"
      class="btn-normal-st btn-normal btn-hover"
      v-show="curTask.STATE === 0"
      size="small"
      >审批不通过</el-button
    >
    <component
      ref="businessComponent"
      style="text-align: left"
      v-show="curTask.STATE === 0"
      class="approveTaskClass"
      @triggerEnd="saveApprove"
      :is="businessComponentName"
    ></component>
    <component
      ref="refuseApproveComponent"
      style="text-align: left"
      v-show="curTask.STATE === 0"
      class="refuseTaskClass"
      @triggerEnd="saveApprove"
      :is="refuseBusinessComponentName"
    ></component>
    <ApprovalFlowDialog
      ref="ApprovalFlowDialog"
      @success="saveApprove"
    ></ApprovalFlowDialog>
    <CreateTaskForm
      ref="CreateTaskForm"
      @success="$emit('successed')"
    ></CreateTaskForm>
    <CreateTask ref="CreateTask" @getValue="$emit('successed')"></CreateTask>
  </div>
</template>

<script>
import {
  GetTaskSettingByTaskType,
  GetTaskBusinessByTaskId,
  GetTaskStateSettingByTaskType,
  ApproveTask,
} from "@/api/modules/basicData/basicTask.js";
import { GetAllManageServerCenterByUserId } from "@/api/modules/basicData/task.js";
import refuseApproveTask from "./refuseApproveTask.vue";
import comps from "ayb-form-design/src/helpers/comps";
import tool from "ayb-form-design/src/helpers/form";
import { GetFormData } from "ayb-form-design/src/api/custmerForm.js"; //GetSchemeEntity
import { SaveTableData } from "ayb-form-design/src/api/databaseTable.js";
import { Flow } from "ayb-form-design/src/api/WfEngine.js";
import { GetSchemeData } from "ayb-form-design/src/api/WFScheme.js";
import formTool from "ayb-form-design/src/helpers/form";
import { NewAuditFlow } from "ayb-form-design/src/api/WfEngine.js";
import { getToken } from "../../util/auth";
import { GetTaskInvokeComponentName } from "./basicTaskHandler.js";
import { GetDeptUser } from "@/api/modules/basicData/user";
import {
  GetTastInfo,
  GetCurrentNodeIds,
  GetList,
} from "ayb-form-design/src/api/WfMyTask.js";
import { getTaskByTaskId } from "@/api/modules/basicData/task";
import ApprovalFlowDialog from "../task/common/ApprovalFlowDialog.vue";
// import { ElSlider } from "element-ui/types/slider";
import { mapState, mapMutations } from "vuex";
const cookieUser = getToken();
export default {
  props: {
    curTask: {
      type: Object,
      default: () => ({
        return: this.$store.state.task.curTask,
      }),
    },
    showCreateButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      businessComponentName: "",
      refuseBusinessComponentName: "",
      hidden: false,
      fightServerCenters: JSON.parse(
        localStorage.getItem("FightServerCenters")
      ),
      curUserServerCenters: JSON.parse(
        localStorage.getItem("ServerCenterMember")
      ),
      approveInfo: {
        Success: true,
      },
      ApprovalInfo: {},
      approval: null,
      node: {},
      typeInfo: {},
    };
  },
  methods: {
    //任务是否操作
    async isOperation(){
      return await getTaskByTaskId(this.curTask.ID,cookieUser.userId).then(res=>{
        return res.ACTUALOPERATETIME!==this.curTask.ACTUALOPERATETIME;
      });
    },
    async refuseApprove() {
      if(await this.isOperation()){
        this.$message.warning('已经操作过，请重新获取重试！')
        return false
      }
      this.$refs.refuseApproveComponent.dialogVisible = true;
    },
    setMemberHidden(curTask, isHidden = true) {
      let Members = curTask.Members;
      console.log("Members", Members);
      if (Members) {
        if (
          Members.filter(
            (p) => p.ALLOWRECEIVE && p.USERID === cookieUser.userId
          ).length > 0
        )
          this.hidden = false;
        else this.hidden = true;
      } else this.hidden = isHidden;
    },
    reapply() {
      let TaskType = JSON.parse(localStorage.getItem("TaskType"));
      if (TaskType.length > 0) {
        let viewType = TaskType.find(
          (item) => item.ID == this.curTask.TASKTYPE
        );
        if (viewType.FORMID) {
          this.$refs.CreateTaskForm.openDialog(viewType, 1, 0, this.curTask);
        } else {
          this.$refs.CreateTask.OpenDialog(viewType, 1, 0, this.curTask);
        }
      } else {
        this.$message.info("未获取到任务类型");
      }
    },
    passApprove() {
      this.$nextTick(() => {
        if (!this.curTask) {
          this.$message({
            message: "请选择一条记录",
            type: "warning",
          });
          return;
        }
        console.log("passApprove");
        if (
          this.businessComponentName &&
          this.businessComponentName !== "div"
        ) {
          this.$refs.businessComponent.dialogVisible = true;
        } else {
          this.saveApprove(null);
        }
      });
    },
    async selectBatch(ApprovalInfo) {
      let options = [];
      let depId = this.departmentId;
      for (let i = 1; i <= ApprovalInfo.approval.length; i++) {
        let approvalType = ApprovalInfo.approvalType[i - 1];
        let approval = ApprovalInfo.approval[i - 1];
        let node = ApprovalInfo.node[i - 1];
        let type = approvalType.type;
        let value = approvalType.value ? approvalType.value : [];
        let info = {
          text: "分支" + i,
          value: i,
          multiple: value.length > 0 ? true : false,
          disabled: value.length > 0 ? true : false,
          selectOptions:[],
          underline:false,
          type: approvalType.type,
        };
        console.log('approvalType.type',approvalType.type)
        switch (approvalType.type) {
          case "user-select":
            info.type="ayb-select-user"
            break;
          case "server-center-select":
            info.type="ayb-select-server-center"
            break;
          case "receiver-select":
            info.multiple=false;
            info.type="ayb-select-receiver"
            break;
          case "post-select":
            info.type="ayb-select-post"
            break;
          case "applicant-department":
            info.type = "ayb-select-department-user";
            break;
          case "department":
            info.type = "ayb-select-department-user";
            depId = node.properties.department.deptId;
            break;
        }

      if (
        Object.keys(approval).length === 0 &&
        Object.keys(approvalType).length !== 0
      ) {
        if (info.type == "ayb-select-department-user") {
          //获取的是部门下用户需要调用接口
          info.selectOptions = await GetDeptUser(depId, 0).then((res) => {
            return res;
          });
        }
        info.componentValue = value.length > 0 ? value : []
      } else if (Object.keys(approvalType).length === 0) {
        info.type='el-input'
        info.disabled=true;
        info.componentValue = approval.auditorName ? approval.auditorName : "结束"
      }else{
        // value = approval.auditorId.split(",").map((v) => {
        //   return "0_" + v;
        // });

        // info.type="ayb-select-user"
        info.componentValue = value.length > 0 ? value : []
        // dynamicFormDesc = {
        //   label: "审批" + name,
        //   type: "user-select",
        //   layout: 24,
        //   attrs: {
        //     isContainContact: false,
        //     multiple: value.length > 0 ? true : false,
        //     disabled: value.length > 0 ? true : false,
        //   },
        //   required: true,
        //   default: value.length > 0 ? value : [],
        //   vif(data) {
        //     return Array.isArray(data.batchType)
        //       ? data.batchType[0].value === index
        //       : data.batchType === index
        //       ? true
        //       : false;
        //   },
        // };
      }
        options.push(info);
      }
      return {
         batchType: {
          label: "选择分支",
          type: "branch-radio",
          default: [1],
          options: options,
         }
        // [
        //   {value:1,text:'分支1',type:'ayb-select-receiver',size:'',componentValue:['10'],selectOptions:[],multiple:false,disabled:false},
        //   {value:2,text:'分支2',type:'ayb-select-user',size:'',componentValue:["4", "45", "5", "44"],selectOptions:[],multiple:true,disabled:false}
        // ]
      };
    },
    // async setDynamicFormDesc(approval, approvalType, node, index) {
    //   let name = "人员";
    //   let value = approvalType.value ? approvalType.value : [];
    //   let type = approvalType.type;
    //   let depId = cookieUser.departmentId;
    //   switch (approvalType.type) {
    //     case "user-select":
    //       name = "人员";
    //       break;
    //     case "server-center-select":
    //       name = "服务台";
    //       break;
    //     case "receiver-select":
    //       name = "接收方";
    //       break;
    //     case "post-select":
    //       name = "岗位";
    //       break;
    //     case "applicant-department":
    //       name = "申请科室负责人";
    //       // approvalType.type = "user-select"
    //       type = "department-user-select";
    //       break;
    //     case "department":
    //       name = "科室部门";
    //       // approvalType.type = "user-select"
    //       type = "department-user-select";
    //       depId = node.properties.department.deptId;
    //       break;
    //   }
    //   let dynamicFormDesc = {};
    //   if (
    //     Object.keys(approval).length === 0 &&
    //     Object.keys(approvalType).length !== 0
    //   ) {
    //     let selectOptions = [];
    //     if (type == "department-user-select") {
    //       //获取的是部门下用户需要调用接口
    //       selectOptions = await GetDeptUser(depId, 0).then((res) => {
    //         return res;
    //       });
    //     }
    //     dynamicFormDesc = {
    //       label: "审批" + name,
    //       type: type,
    //       layout: 24,
    //       attrs: {
    //         isContainContact: false,
    //         multiple: value.length > 0 ? true : false,
    //         disabled: value.length > 0 ? true : false,
    //         selectOptions: selectOptions,
    //       },
    //       required: true,
    //       default: value.length > 0 ? value : [],
    //       vif(data) {
    //         return Array.isArray(data.batchType)
    //           ? data.batchType[0].value === index
    //           : data.batchType === index
    //           ? true
    //           : false;
    //       },
    //     };
    //   } else if (Object.keys(approvalType).length === 0) {
    //     dynamicFormDesc = {
    //       label: "审批人员",
    //       type: "text",
    //       category: 1,
    //       layout: 24,
    //       default: approval.auditorName ? approval.auditorName : "结束",
    //       vif(data) {
    //         console.log("data.batchType", data.batchType);
    //         return Array.isArray(data.batchType)
    //           ? data.batchType[0].value === index
    //           : data.batchType === index
    //           ? true
    //           : false;
    //       },
    //     };
    //   } else {
    //     value = approval.auditorId.split(",").map((v) => {
    //       return "0_" + v;
    //     });
    //     dynamicFormDesc = {
    //       label: "审批" + name,
    //       type: "user-select",
    //       layout: 24,
    //       attrs: {
    //         isContainContact: false,
    //         multiple: value.length > 0 ? true : false,
    //         disabled: value.length > 0 ? true : false,
    //       },
    //       required: true,
    //       default: value.length > 0 ? value : [],
    //       vif(data) {
    //         return Array.isArray(data.batchType)
    //           ? data.batchType[0].value === index
    //           : data.batchType === index
    //           ? true
    //           : false;
    //       },
    //     };

    //     // {
    //     //   label: "审批人员",
    //     //   type: "text",
    //     //   category: 1,
    //     //   layout: 12,
    //     //   default: approvalType.label,
    //     //   vif(data) {
    //     //     console.log("data.batchType", data.batchType);
    //     //     return Array.isArray(data.batchType)
    //     //       ? data.batchType[0].value === index
    //     //       : data.batchType === 1
    //     //       ? false
    //     //       : true;
    //     //   },
    //     // };
    //   }

    //   return dynamicFormDesc;
    // },
    async saveApprove(val, formdata) {
      if(await this.isOperation()){
        this.$message.warning('已经操作过，请刷新重试！')
        return false
      }
      this.approveInfo = {
        Success: true,
      };
      let index = 0;
      let count = 0;

      if (val) this.approveInfo = val;
      this.approveInfo.TaskId = this.curTask.ID;
      this.approveInfo.TaskType = this.curTask.TASKTYPE;
      this.approveInfo.ApproveUserInfo = {
        ID: cookieUser.userId,
        NAME: cookieUser.realName,
        DEPTID: cookieUser.departmentId,
        DEPTNAME: cookieUser.departmentName,
        COMPANYID: cookieUser.organizationId,
        COMPANYNAME: cookieUser.organizationName,
      };
      let TaskType = JSON.parse(localStorage.getItem("TaskType"));
      this.typeInfo = {};
      if (TaskType.length > 0) {
        let typelist = TaskType.filter(
          (item) => item.ID == this.curTask.TASKTYPE
        );
        if (typelist.length > 0) {
          this.typeInfo = typelist[0];
        }
      }
      if (this.typeInfo.FLOWID) {
        let dbTable = [];
        let node = await GetSchemeData(this.typeInfo.FLOWID).then((result) => {
          if (result.code === 200) {
            // dbTable = JSON.parse(result.data.schemeEntity.F_Scheme).dbTable;
            return JSON.parse(result.data.schemeEntity.F_Scheme).node;
          } else {
            this.$message.warning("获取模板数据有问题，请重试！");
          }
        });

        if (this.typeInfo.FORMID) {
          dbTable = await GetFormData(this.typeInfo.FORMID).then((result) => {
            return JSON.parse(result.schemeEntity.F_Scheme).dbTable;
          });
        }

        if (this.approveInfo.Success) {
          let taskNodeInfo = await GetCurrentNodeIds(this.curTask.ID).then(
            (result) => {
              return result.data;
            }
          );

          this.node = node;
          let ApprovalInfo = await formTool.getApproval(
            node,
            taskNodeInfo[0],
            {},
            1,
            1,
            dbTable.length > 0
              ? {
                  tablename: dbTable[0].name,
                  taskid: this.curTask.ID,
                }
              : "",
            {
              userid: this.curTask.CREATEUSERID,
              username: this.curTask.CREATEUSERNAME,
              depid: this.curTask.CREATEDEPTID,
              depname: this.curTask.CREATEDEPTNAME,
            }
          );
          this.ApprovalInfo = ApprovalInfo;
          console.log("this.ApprovalInfo", this.ApprovalInfo);
          // count = this.ApprovalInfo.approvalType.length; //获取总数，大于1说明有分支
          // if (!this.ApprovalInfo.isFinished) {
          if (formdata) {
            this.approveInfo.NextServerCenterInfo = {
              Name: null,
              Value: null,
            };
            this.approveInfo.NextUserInfo = [];
            // {
            //   ID: null,
            //   NAME: null,
            //   DEPTID: null,
            //   DEPTNAME: null,
            //   COMPANYID: null,
            //   COMPANYNAME: null,
            // };
            if (formdata.description) {
              this.approveInfo.Memo = formdata.description; //获取流程审批意见
            }

            if (this.ApprovalInfo.approval.length > 1) {
              // index = Array.isArray(formdata.batchType)
              //   ? formdata.batchType[0].value
              //   : formdata.batchType;
              index = Array.isArray(formdata.batchType)
              ? formdata.batchType[0].radio
              : formdata.batchType.radio;
              index = index - 1;
              this.ApprovalInfo.approvalType = this.ApprovalInfo.approvalType[
                index
              ];
              this.ApprovalInfo.node = this.ApprovalInfo.node[index];

              this.ApprovalInfo.approval =
                Object.keys(this.ApprovalInfo.approval[index]).length === 0
                  ? []
                  : [this.ApprovalInfo.approval[index]];
              console.log(
                "this.ApprovalInfo.approval",
                this.ApprovalInfo.approval
              );
              console.log(
                "this.ApprovalInfo.approval length",
                this.ApprovalInfo.approval.length
              );
              if(formdata.batchType.value.length===0){
                this.$message.warning('分支'+(index+1)+'请选择审批对象');
                return false;
              }
              // if (this.ApprovalInfo.approval.length == 0) {
              formdata.approval = formdata.batchType.info.approval//formdata["approval" + (index + 1)];
              // }
            }
            console.log("formdata.approval", formdata.approval);
            // let approval = formdata.approval
            //   ? Array.isArray(formdata.approval)
            //     ? formdata.approval[0]
            //     : formdata.approval
            //   : this.ApprovalInfo.approval[0];
            let approval = formdata.approval
              ? Array.isArray(formdata.approval)
                ? formdata.approval[0]
                : formdata.approval
              : this.ApprovalInfo.approval[0];
            console.log("receiver", approval);
            if (approval === "结束" || !approval) {
              this.ApprovalInfo.isFinished = true; //审批结束
            }
            // console.log('this.ApprovalInfo.approvalType.type',this.ApprovalInfo.approvalType.type);
            let approvalType = Array.isArray(this.ApprovalInfo.approvalType)
              ? this.ApprovalInfo.approvalType[0]
              : this.ApprovalInfo.approvalType;
            switch (approvalType.type) {
              case "user-select":
              case "applicant-department":
              case "department":
                if (Array.isArray(formdata.approval)) {
                  let arr = [];
                  const approvalTypeUser = this.ApprovalInfo.approvalType.type;
                  formdata.approval.forEach((item) => {
                    arr.push({
                      ID: item.UserId,
                      NAME: item.Name,
                      DEPTID: item.DeptId,
                      DEPTNAME: item.DeptName,
                      COMPANYID: "",
                      COMPANYNAME: "",
                    });
                    this.approveInfo.NextUserInfo = arr;
                  });
                } else {
                  this.approveInfo.NextUserInfo = [
                    {
                      ID: approval.UserId,
                      NAME: approval.Name,
                      DEPTID: approval.DeptId,
                      DEPTNAME: approval.DeptName,
                      COMPANYID: "",
                      COMPANYNAME: "",
                    },
                  ];
                }

                break;
              case "server-center-select":
                this.approveInfo.NextServerCenterInfo = {
                  Name: approval.NAME,
                  Value: approval.ID,
                };
                break;
              case "receiver-select":
                if (approval.Key.length > 8) {
                  this.approveInfo.NextServerCenterInfo = {
                    Name: approval.Name,
                    Value: approval.Key,
                  };
                } else {
                  this.approveInfo.NextUserInfo = [
                    {
                      ID: approval.Key,
                      NAME: approval.Name,
                      DEPTID: approval.ParentKey,
                      DEPTNAME: approval.ParentName,
                      COMPANYID: "",
                      COMPANYNAME: "",
                    },
                  ];
                }
                break;
              case "post-select":
                this.$message.error("目前不支持岗位审批功能");
                break;
              default:
                break;
            }
          } else {
            let formDesc = {};
            if (ApprovalInfo.approval.length > 1) {
              let i = 1;
              let options = [];
              let formArr = {};

              // for (let i = 1; i <= ApprovalInfo.approval.length; i++) {
              //   options.push({
              //     text: "分支" + i,
              //     value: i,
              //   });
              //   formArr["approval" + i] = await this.setDynamicFormDesc(
              //     ApprovalInfo.approval[i - 1],
              //     ApprovalInfo.approvalType[i - 1],
              //     ApprovalInfo.node[i - 1],
              //     i
              //   ).then((res) => {
              //     return res;
              //   });
              // }
              
              // let value = ApprovalInfo.approvalType[0].value
              //   ? ApprovalInfo.approvalType[0].value
              //   : [];
              // formArr = Object.assign(
              //   {
              //     batchType: {
              //       options: options,
              //       default: 1,
              //       category: 1,
              //       label: "选择分支",
              //       type: "radio",
              //       layout: 24,
              //     },
              //   },
              //   formArr
              // );
              formArr = await this.selectBatch(ApprovalInfo)
              console.log('selectBatch formArr',formArr)
              formDesc = Object.assign(formArr, formDesc);
            } else {
              formDesc = tool.getApprovalformDesc({}, ApprovalInfo, 0);
            }
            formDesc.description = {
              label: "审批意见",
              type: "editor",
              default: "",
              required: false,
            };

            console.log("formDesc", formDesc);
            this.$refs.ApprovalFlowDialog.openDialog(formDesc, val);
            return false;
          }
          if (this.ApprovalInfo.isFinished) {
            //通过如果是流程结束
            delete this.approveInfo.NextUserInfo;
            delete this.approveInfo.NextServerCenterInfo;
            // this.ApprovalInfo.isFinished = true;
            // this.approveInfo.Success = false;
          }
          // }
        } else {
          //不通过
          // let taskNodeList = await GetList(this.curTask.ID).then((result) => {
          //   return result.data;
          // });
          // if (taskNodeList.length > 0) {
          //   let taskNodeInfo = taskNodeList[0];
          //   if (taskNodeInfo.F_ModifyUserId.length > 8) {
          //     this.approveInfo.NextServerCenterInfo = {
          //       Name: taskNodeInfo.F_ModifyUserId,
          //       Value: taskNodeInfo.F_ModifyUserName,
          //     };
          //   } else {
          //     this.approveInfo.NextUserInfo = {
          //       ID: taskNodeInfo.F_ModifyUserId,
          //       NAME: taskNodeInfo.F_ModifyUserName,
          //       DEPTID: "",
          //       DEPTNAME: "",
          //       COMPANYID: "",
          //       COMPANYNAME: "",
          //     };
          //   }
          // }
          delete this.approveInfo.NextUserInfo;
          delete this.approveInfo.NextServerCenterInfo;
          // console.log("approveInfo", this.approveInfo);
        }
      }
      console.log("approveInfo", this.approveInfo);
      this.$refs.ApprovalFlowDialog.cancel()

      // return false;
      ApproveTask(this.approveInfo).then((result) => {
        if (result.ResultCode > 0) {
          if (this.typeInfo.FLOWID) {
            let approvalAuditers = {};
            if (formdata) {
              approvalAuditers = tool.getAuditers(
                formdata,
                this.ApprovalInfo,
                index
              );
            } else {
              if (this.approveInfo.Success)
                approvalAuditers = this.ApprovalInfo.approval[0];
            }
            NewAuditFlow(
              "",
              this.curTask.ID,
              this.approveInfo.Success ? 1 : 2,
              this.approveInfo.Memo == undefined ? "" : this.approveInfo.Memo,
              JSON.stringify(this.approveInfo.Success ? approvalAuditers : ""),
              JSON.stringify(
                this.approveInfo.Success ? this.ApprovalInfo.node : {}
              ), //JSON.stringify(currentNode),
              JSON.stringify({}),
              this.approveInfo.Success ? this.ApprovalInfo.isFinished : true
            ).then((res) => {
              if (res.status !== 1) {
                this.$message.error("失败");
              } else {
                this.$message({
                  message: "审核成功",
                  type: "success",
                });
                this.$emit("successed");
              }
            });
          } else {
            this.$message({
              message: "审核成功",
              type: "success",
            });
            this.$emit("successed");
          }
        } else {
          this.$message.error({
            message: "审核失败：" + result.MsgInfo,
          });
        }
      });
    },
    _initialComponent(taskType, taskClass) {
      //初始化审批控件
      GetTaskInvokeComponentName(taskType, taskClass, 2).then(
        (componentName) => {
          this.businessComponentName = componentName;
          setTimeout(() => {
            $(".approveTaskClass").hide();
          });
          console.log("控件名", componentName);
        }
      );
      GetTaskInvokeComponentName(taskType, taskClass, 1).then(
        (componentName) => {
          if (componentName && componentName !== "div") {
            this.refuseBusinessComponentName = componentName;
          } else {
            this.refuseBusinessComponentName = "refuseApproveTask";
          }
          setTimeout(() => {
            $(".refuseTaskClass").hide();
          });
          console.log("控件名", componentName);
        }
      );
    },
  },
  watch: {
    curTask: function (newvalue) {
      if (!newvalue) return;
      if (Object.keys(newvalue).length == 0) return;
      console.log(newvalue.INSTANCE);
      console.log(newvalue.TASKTYPENAME);
      let taskType = newvalue.TASKTYPE;
      let taskClass = newvalue.TASKCLASS;
      let taskState = newvalue.STATE;
      this._initialComponent(taskType, taskClass);
      //判断是否能审批
      if (this.curTask.EXCUTEUSERID === cookieUser.userId) {
        this.hidden = false;
      } else if (this.curUserServerCenters)
        if (
          this.curUserServerCenters.indexOf(this.curTask.SERVERCENTERID) !== -1
        ) {
          this.hidden = false;
        } else {
          this.setMemberHidden(newvalue);
        }
      else {
        this.setMemberHidden(newvalue, true);
      }
    },
  },
  mounted() {
    if (!this.curTask) return;
    this.businessComponentName = "";
    this.refuseBusinessComponentName = "";
    let taskType = this.curTask.TASKTYPE;
    let taskClass = this.curTask.TASKCLASS;
    let taskState = this.curTask.STATE;
    if (taskType) {
      this._initialComponent(taskType, taskClass);
    }
    //判断是否能审批
    if (this.curTask.EXCUTEUSERID === cookieUser.userId) {
      this.hidden = false;
    } else if (this.curUserServerCenters) {
      if (this.curUserServerCenters.indexOf(this.curTask.SERVERCENTERID) !== -1)
        this.hidden = false;
      else this.setMemberHidden(this.curTask);
    } else {
      this.setMemberHidden(this.curTask, true);
    }
  },
  computed: {
    ...mapState({
        userId: (state) => state.task.userId,
        userName: (state) => state.task.realName,
        departmentId: (state) => state.user.departmentId,
    }),
  },
  components: {
    refuseApproveTask,
    ApprovalFlowDialog,
  },
};
</script>
<style scoped>
/* .approveDialog .el-dialog__wrapper {
  z-index: 1;
} */
</style>
<style scoped>
.btn-hidden {
  visibility: hidden;
}
.btn-normal {
  float: left;
  margin: 0 2px;
}
.btn-normal-st,
.btn-normal-st:focus {
  height: 40px;
  /* width: ; */
  /* padding-left: 20px;
  padding-right: 20px; */
  min-width: 116px;
  margin-right: 8px;
  border: 1px solid transparent;
  border-radius: 24px;
  font-size: 16px;
  text-align: center;
  color: #666666;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(24, 144, 255, 0.2);
}
.btn-normal-st:hover {
  background: #1890ff;
}
.btn-normal-st:active {
  background: #1681e5;
}
.create-btn >>> .el-button:hover {
  color: #fff;
  background: #1890ff;
}
.btn-hover:hover{
  color: #fff;
  background: #1890ff;
}
.create-btn >>> .el-button:active {
  background: #1681e5;
}
.create-btn >>> .el-button {
  width: 116px;
  height: 40px;
  margin-right: 8px;
  border: 1px solid transparent;
  border-radius: 24px;
  font-size: 16px;
  text-align: center;
  color: #ffffff;
  background: #1890ff;
  box-shadow: 0px 0px 10px 0px rgba(24, 144, 255, 0.2);
}
</style>
